import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import api from '../api'
import CompanyStatusBadge from './CompanyStatusBadge'
import Card from './cards/Card'
import { apiErrorText } from '../utils/apiError'
import Table from './Table'
import styles from './CompanyAdmins.module.css'

const CompanyAdmins = forwardRef((_, ref) => {
  const [error, setError] = useState('')
  const [admins, setAdmins] = useState([])
  const [adminsLoading, setAdminLoading] = useState(false)

  const getAdmins = useCallback(async () => {
    setAdminLoading(true)
    try {
      const response = await api.get('/company/admins')
      const nextAdmins = response || []
      setAdmins(nextAdmins)
    } catch (e) {
      console.error(e)
      setError(apiErrorText(e))
    }
    setAdminLoading(false)
  }, [])

  useEffect(() => {
    getAdmins()
  }, [getAdmins])

  useImperativeHandle(ref, () => ({
    onAddClick: () => null,
  }))


  return (
    <div className={styles.container}>
      {error && <div role="alert" className={styles.error}>{error}</div>}
      <Card appearance="modern" integratedTable title="Amministratori aziendali">
      <Table
      integrated
        columns={[
          { key: 'id', label: 'ID', type: 'number' },
          { key: 'name', label: 'NOME', type: 'string' },
          { key: 'surname', label: 'COGNOME', type: 'string' },
          { key: 'email', label: 'EMAIL', type: 'string' },
          { key: 'status', label: 'STATO', type: 'custom' },
          { key: 'registered_at', label: 'REGISTRATO IL', type: 'datetime' },
          { key: 'last_access', label: 'ULTIMO ACCESSO', type: 'datetime' },
        ]}
        loading={adminsLoading}
        elements={admins.map((admin) => ({
          ...admin,
          company_role: String(admin.company_role || admin.role || 'N/A').toUpperCase(),
          status: { value: admin.status, type: 'string', component: <CompanyStatusBadge status={admin.status} /> },
        }))}
        defaultSort={{ key: 'registered_at', direction: 'desc' }}
      />
      {!adminsLoading && !error && admins.length === 0 && <p className={styles.emptyState}>Nessun amministratore aziendale.</p>}
      </Card>
    </div>
  )
})

export default CompanyAdmins
